/* eslint-disable @typescript-eslint/explicit-member-accessibility */
export class ConsultationAnswer {
	id: number;
	answer: string;
	case_question_id: number;
}
